import { Skeleton } from '@/components/ui/skeleton'

const SLOT_DAY_COUNT = 4

const SLOT_COUNT = 3

export const MigrationScheduleFallback = () => (
  <div className="flex flex-col gap-3 rounded-lg border p-3">
    <div className="flex items-start justify-between gap-3">
      <div className="flex flex-col gap-1.5">
        <Skeleton className="h-5 w-56" />
        <Skeleton className="h-3 w-36" />
      </div>
      <Skeleton className="h-8 w-36" />
    </div>
    <Skeleton className="h-3 w-full" />
    <Skeleton className="h-3 w-4/5" />
  </div>
)

export const MigrationNotesFallback = () => (
  <div className="flex flex-col gap-3">
    <div className="flex flex-col gap-1.5">
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-3 w-72 max-w-full" />
    </div>
    <Skeleton className="h-16 w-full" />
    <div className="flex items-center justify-between">
      <Skeleton className="h-3 w-16" />
      <Skeleton className="h-8 w-24" />
    </div>
  </div>
)

export const SlotPickerFallback = () => (
  <div className="flex flex-col gap-4">
    <Skeleton className="h-3 w-56" />
    <div className="flex flex-col divide-y rounded-md border">
      {Array.from({ length: SLOT_DAY_COUNT }).map((_, index) => (
        <div
          key={index}
          className="grid gap-2 px-3 py-2 sm:grid-cols-[7rem_minmax(0,1fr)] sm:items-center sm:gap-3"
        >
          <Skeleton className="h-4 w-20" />
          <div className="flex gap-1.5">
            {Array.from({ length: SLOT_COUNT }).map((_, slotIndex) => (
              <Skeleton key={slotIndex} className="h-8 w-14" />
            ))}
          </div>
        </div>
      ))}
    </div>
    <Skeleton className="h-4 w-48" />
    <Skeleton className="h-16 w-full" />
  </div>
)
